import { render, staticRenderFns } from "./deposit-setting.vue?vue&type=template&id=504edb70"
import script from "./deposit-setting.vue?vue&type=script&lang=js"
export * from "./deposit-setting.vue?vue&type=script&lang=js"
import style0 from "./deposit-setting.vue?vue&type=style&index=0&id=504edb70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports